import { UPDATE_ARBEITSBEREICH_STATION } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useUpdateArbeitsbereichStation/graphql/mutation';
import {
  Rotationsplan_UpdateArbeitsbereichStationMutation,
  Rotationsplan_UpdateArbeitsbereichStationMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateArbeitsbereichStation() {
  const [execute, result] = useMutation<
    Rotationsplan_UpdateArbeitsbereichStationMutation,
    Rotationsplan_UpdateArbeitsbereichStationMutationVariables
  >(UPDATE_ARBEITSBEREICH_STATION, {
    refetchQueries: ['mitarbeiter_rotationsplanById'],
    awaitRefetchQueries: true,
  });

  const updateArbeitsbereichStation = useCallback(
    (variables: Rotationsplan_UpdateArbeitsbereichStationMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [updateArbeitsbereichStation, result] as const;
}
